import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import QueryManager from './Query';

const GET_TOTAL_ORDERS_COUNTERS_BY_PENDINDS = gql`
    query getTotalOrdersCountersByPendings(
        $filters: TotalOrdersCountersByPendingsInput
    ) {
        getTotalOrdersCountersByPendings(filters: $filters) {
            message
            internalCode
            data {
                salesChannel
                count
                status
            }
        }
    }
`;

const getTotalOrdersCountersByPendings = ({ children, ...props }) => (
    <QueryManager query={GET_TOTAL_ORDERS_COUNTERS_BY_PENDINDS} {...props}>
        {({ data, loading, refetch }) =>
            children({
                data,
                loading,
                refetch
            })
        }
    </QueryManager>
);

getTotalOrdersCountersByPendings.propTypes = {
    children: PropTypes.any
};

export default getTotalOrdersCountersByPendings;
